(function () {
  var MOBILE_MAX = 989;

  function placeMobileShop() {
    var mobileShop = document.querySelector('[data-blog-shop-mobile]');
    var main = document.querySelector('main[data-template="article"]');
    if (!mobileShop || !main) return;

    var coverSection = mobileShop.closest('.shopify-section') || mobileShop.parentElement;

    if (window.innerWidth < MOBILE_MAX) {
      if (mobileShop.parentElement !== main) {
        main.appendChild(mobileShop);
      }
      mobileShop.hidden = false;
      return;
    }

    if (coverSection && mobileShop.parentElement !== coverSection) {
      coverSection.appendChild(mobileShop);
    }
    mobileShop.hidden = true;
  }

  document.addEventListener('DOMContentLoaded', placeMobileShop);
  window.addEventListener('resize', placeMobileShop);
  document.addEventListener('shopify:section:load', placeMobileShop);
})();
